import React, { Component } from "react";
import PropTypes from "prop-types";
import { Collapse, Button } from "antd";
import { IconLight } from "../icon_light";

//import "./selectorGroup.css";

class SelectorGroup extends Component {
  // state = {
  //   isCollapsed: false
  //   // isSwitchEnabled: this.props.isEnabled
  // };
  //
  // //collapser is allowed only in on mode
  // //when switch is turned on, then by default, collapse will open and vice a versa
  // toggleCollapser = () => {
  //   this.setState(prevState => ({
  //     isCollapsed: prevState.isSwitchEnabled ? !prevState.isCollapsed : true
  //   }));
  // };
  //
  // toggleSwitch = mode => {
  //   this.setState(
  //     {
  //       isSwitchEnabled: mode
  //     },
  //     () => this.props.handleToggle()
  //   );
  // };

  render() {
    const { heading, body, onRemoveGroup } = this.props;
    // const { isCollapsed } = this.state;
    return (
      <div className={"cp-selector-group"} style={{ margin: "8px" }}>
        <Collapse
          style={{
            marginTop: "8px"
          }}
          defaultActiveKey={["1"]}
          //activeKey={isCollapsed ? [] : ["1"]}
          // onChange={this.toggleCollapser}
        >
          <Collapse.Panel
            key={"1"}
            header={
              <div>
                {/*<Switch*/}
                {/*className="cp-switch"*/}
                {/*checkedChildren="ON"*/}
                {/*unCheckedChildren="OFF"*/}
                {/*defaultChecked={isEnabled}*/}
                {/*size="default"*/}
                {/*// size="small"*/}
                {/*onChange={this.toggleSwitch}*/}
                {/*style={{ float: "right", marginRight: "8px" }}*/}
                {/*/>*/}
                <span>{heading.toUpperCase()}</span>
                <Button
                  style={{
                    background: "transparent",
                    float: "right",
                    border: 0,
                    marginTop: "-4px"
                  }}
                  onClick={onRemoveGroup}
                >
                  <IconLight icon={"trash-alt"} />
                </Button>
              </div>
            }
            //   style={{
            //     backgroundColor: isEnabled ? "#fff" : "#ccc"
            //   }}
          >
            {body}
          </Collapse.Panel>
        </Collapse>
      </div>
    );
  }
}

SelectorGroup.propTypes = {
  heading: PropTypes.string.isRequired,
  body: PropTypes.any.isRequired,
  onRemoveGroup: PropTypes.func.isRequired
  //isEnabled: PropTypes.bool.isRequired,
  //  handleToggle: PropTypes.func.isRequired
};

export default SelectorGroup;



// WEBPACK FOOTER //
// ./src/views/components/selector_group/SelectorGroup.jsx